import { useAuthenticatedSession } from '../../auth/session'
import { useT } from '../../i18n'
import styles from '../note.module.css'

/**
 * The explanatory block the admin screens carry, on the daily working
 * screen: what the list shows, where its scope comes from, how the filters
 * and the export behave. Collapsed by default so a routine visit is not
 * pushed down the page; one click opens it.
 */
export function TransactionsNote() {
  const t = useT()
  const { user } = useAuthenticatedSession()
  return (
    <details className={styles.note}>
      <summary className={styles.summary}>{t('tx.note.title')}</summary>
      <div className={styles.body}>
        <p className={styles.key}>{t('tx.note.scope')}</p>
        <p>{t('tx.note.dates')}</p>
        <p>{t('tx.note.filters')}</p>
        <p>{t('tx.note.columns')}</p>
        <p>{t('tx.note.export')}</p>
        {/* The switcher and the identity search exist for internal users only;
            telling an organisation user about them would only raise questions. */}
        {user.isInternal && <p>{t('tx.note.internal')}</p>}
      </div>
    </details>
  )
}
